/* eslint class-methods-use-this: ["error",
{ "exceptMethods": ["parseQueryString", "getParamsFromUrl",
"ageCal"] }] */
export default class CommonFunctions {
  parseQueryString(url) {
    const query = url;
    const vars = query.split('&');
    const queryString = {};
    for (let i = 0; i < vars.length; i += 1) {
      const pair = vars[i].split('=');
      // If first entry with this name
      if (typeof queryString[pair[0]] === 'undefined') {
        queryString[pair[0]] = decodeURIComponent(pair[1]);
        // If second entry with this name
      } else if (typeof queryString[pair[0]] === 'string') {
        const arr = [queryString[pair[0]], decodeURIComponent(pair[1])];
        queryString[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        queryString[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }
    return queryString;
  }

  getParamsFromUrl(url) {
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    const obj = {};

    if (queryString) {
      queryString = queryString.split('#')[0];
      const arr = queryString.split('&');

      for (let i = 0; i < arr.length; i += 1) {
        const a = arr[i].split('=');
        let paramNum = 0;
        let paramName = a[0].replace(/\[\d*\]/, (v) => {
          paramNum = v.slice(1, -1);
          return '';
        });
        let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
        if (paramValue) {
          paramName = paramName.toLowerCase();
          paramValue = paramValue.toLowerCase();
          if (obj[paramName]) {
            if (typeof obj[paramName] === 'string') {
              obj[paramName] = [obj[paramName]];
            }
            if (typeof paramNum === 'undefined') {
              obj[paramName].push(paramValue);
            } else {
              obj[paramName][paramNum] = paramValue;
            }
          } else {
            obj[paramName] = paramValue;
          }
        }
      }
    }
    return obj;
  }

  ageCal(birthday) {
    const year = parseInt(new Date().getFullYear(), 10);
    const age = birthday;
    const ageSub2 = age.substr(0, 2);
    let ageSub0 = 19;
    if (ageSub2 < 20) {
      ageSub0 = 20;
    }
    const ck = `${ageSub0}${ageSub2}`;

    return (year - parseInt(ck, 10)) + 1; // 우리나라 나이 표시 +1 더함
  }
}



// WEBPACK FOOTER //
// ./src/common-functions/commonFuntions.js